"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  Browse: "Durchsuchen",
  Change: "Ändern",
  "Drop your image here": "Legen Sie Ihr Bild hier ab",
  "Drop your logo here": "Legen Sie Ihr Logo hier ab",
  Remove: "Entfernen",
  "Revert to default": "Auf Standard zurücksetzen",
  "Sorry, \"{fileName}\" is larger than {maxFileSize} and can't be uploaded. Please upload a file that's {maxFileSize} or smaller.": ["„", ["fileName"], "“ ist größer als ", ["maxFileSize"], " und kann nicht hochgeladen werden. Bitte laden Sie eine Datei hoch, die ", ["maxFileSize"], " oder kleiner ist."],
  "Sorry, \"{fileName}\" is smaller than {minFileSize} and can't be uploaded. Please upload a file that's {minFileSize} or larger.": ["„", ["fileName"], "“ ist kleiner als ", ["minFileSize"], " und kann nicht hochgeladen werden. Bitte laden Sie eine Datei hoch, die ", ["minFileSize"], " oder größer ist."],
  "Sorry, this image format isn't supported. Please provide a {fileTypes}.": ["Leider wird das Bildformat nicht unterstützt. Bitte geben Sie ein ", ["fileTypes"], " an."],
  "Unsupported file type": "Nicht unterstützter Dateityp"
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map